import { RouteComponentProps } from 'react-router-dom';
import { PaymentPartial } from 'types/Payment';
import ClickToPay from 'components/clickToPay/ClickToPay';
import { ICardContext } from '../../types/CardContext';
import { LocaleContextProviderProps } from '../../services/LocaleProvider/LocaleProvider.types';
import { ISelectedMethodContext } from '../../types/SelectedMethodContext';
import Blik from '../blik/Blik';
import Card from '../card/Card';
import GPay from '../gpay/GPay';
import ApplePay from '../applePay/ApplePay';
import PBL from '../pbl/PBL';
import PayPo from '../paypo/PayPo';
import BlikIcon from '../../assets/images/blik_icon.svg';
import CardIcon from '../../assets/images/card_icon.svg';
import CardRecurringIcon from '../../assets/images/card_recurring_icon.svg';
import GpayIcon from '../../assets/images/gpay_icon.svg';
import ApplePayIcon from '../../assets/images/applepay_icon.svg';
import PBLIcon from '../../assets/images/transfer_icon.svg';
import PayPoIcon from '../../assets/images/paypo_icon.svg';
import ClickToPayIcon from '../../assets/images/c2p_icon.svg';
import { IAppState } from '../../types/ApplicationState';

export interface IAppPaymentProps
  extends RouteComponentProps<{
      paymentId: string;
    }>,
    Partial<ICardContext>,
    Partial<LocaleContextProviderProps>,
    Partial<ILicenseNoteContext>,
    Partial<ISelectedMethodContext>,
    Partial<ITextContext>,
    Partial<IAppState> {
  setPaymentDetails: (paymentDetails: PaymentPartial, paymentId: string) => void;
}

export const COMPONENT_BY_TYPE = {
  BLIK: Blik,
  CARD: Card,
  CARD_RECURRING: Card,
  GOOGLE_PAY: GPay,
  APPLE_PAY: ApplePay,
  PBL,
  PAYPO: PayPo,
  CLICK_TO_PAY: ClickToPay,
};

export const IMAGE_BY_TYPE = {
  BLIK: BlikIcon,
  CARD: CardIcon,
  CARD_RECURRING: CardRecurringIcon,
  GOOGLE_PAY: GpayIcon,
  APPLE_PAY: ApplePayIcon,
  PBL: PBLIcon,
  PAYPO: PayPoIcon,
  CLICK_TO_PAY: ClickToPayIcon,
};
